import { CapManageControllerContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/CapManageEntityFlow.tsx';
import { useContext, useState } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';

import { deletePersonEmploymentRecordRequest } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/apis/useEmploymentRecords.ts';
import { getPersonEmploymentRecords } from '@dealstack/frontend/app/services/Person.service.ts';
import { EmploymentRecordRes } from '@dealstack/shared/lib/generated';

export const useEmploymentRecords = () => {
	const { selectedEntityId } = useContext(CapManageControllerContext);
	const [addEmploymentRecord, setAddEmploymentRecord] = useState<boolean>(false);
	const [editEmploymentRecord, setEditEmploymentRecord] = useState<EmploymentRecordRes | null>(
		null
	);
	const [deleteEmploymentRecord, setDeleteEmploymentRecord] =
		useState<EmploymentRecordRes | null>(null);

	const {
		data: employmentRecords,
		isFetching: employmentRecordsFetching,
		refetch: refetchEmploymentRecords,
	} = useQuery({
		queryKey: ['employmentRecords', selectedEntityId],
		queryFn: () => getPersonEmploymentRecords(selectedEntityId),
		enabled: !!selectedEntityId,
	});

	const deletePersonEmploymentRecordMutation = useMutation({
		mutationFn: deletePersonEmploymentRecordRequest,
	});

	const deletePersonEmploymentRecord = () => {
		if (!deleteEmploymentRecord) {
			return;
		}

		deletePersonEmploymentRecordMutation.mutate(
			{ employmentRecordId: deleteEmploymentRecord.id },
			{
				onSuccess: () => {
					void refetchEmploymentRecords();
					setDeleteEmploymentRecord(null);
				},
			}
		);
	};

	return {
		employmentRecords: employmentRecords ?? [],
		isEmploymentRecordsLoading: employmentRecordsFetching,
		refetchEmploymentRecords,
		deletePersonEmploymentRecord,
		deleteEmploymentRecord,
		setDeleteEmploymentRecord,
		editEmploymentRecord,
		setEditEmploymentRecord,
		addEmploymentRecord,
		setAddEmploymentRecord,
		deletePersonEmploymentRecordLoading: deletePersonEmploymentRecordMutation.isPending,
		deletePersonEmploymentRecordSuccess: deletePersonEmploymentRecordMutation.isSuccess,
	};
};
